module.exports = __webpack_public_path__ + "static/media/rollerblade.12ae0d79.gif";